import React, { Component } from "react";
import Collapsible from '../components/Collapsible';
import {Glyphicon} from 'react-bootstrap';
import { Grid, Paper, Typography, Button } from "@material-ui/core";


export default class Help extends Component {

    constructor(props){
        super(props);
        props.setTitle('Help');
    }

    render() {
        return (
        <div className="Home">
                <div className="container">
                    <Paper style={{width: "100%", marginBottom: 10, paddingTop : '15px', paddingLeft: "5px", paddingRight: "5px", paddingBottom: 10}}>
                        <Grid container justify="flex-end">
                            <Grid item xs={12} lg={6}>
                                <Typography variant="h6" style={{paddingLeft: 20, textAlign: 'left', paddingBottom: 10}}>Download Mobile App Feature Document</Typography>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={() => {
                                        window.open(`${process.env.PUBLIC_URL}/HappyMilk App Document.docx`, "_blank")
                                    }}
                                >
                                    Download File
                                </Button>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Collapsible key="Agent" title="Agent">
                        <h3>Create Agent</h3>
                        <div style={{textAlign: "left"}}>
                            <ol>
                                <li>Click on the + Button</li>
                                <li>Assign <b>Roles</b> to the agent. (On highlighting the roles, you can see the access it grants)</li>
                                <li>Click <b>Create Agent</b> button</li>
                                <li>Once the agents are created, they will be in deactivated state. To activate an agent click on <b>Activate/Deactivate</b> icon. Once active they will be able to log into the mobile devices.</li>
                            </ol>
                        </div>
                        <br/>

                        <h3>Deactivate / Activate Agent</h3>
                        <div style={{textAlign: "left"}}>
                            <ol>
                                <li>Go to the <b>Agents</b> page.</li>
                                <li>Click on the <b>Activate/Deactivate</b> icon to toggle activation status.
                                    <br/><b>Note:</b> Once deactivated, the agent will not be able to log into the Delivery App on the mobile device.
                                </li>
                            </ol>
                        </div>
                        <br/>

                        <h3>Terminate/Remove Agent</h3>
                        <div style={{textAlign: "left"}}>
                            <ol>
                                <li>Go to the <b>Agents</b> page.</li>
                                <li>Check if the <b>Agent</b> is mapped to a <b>Route</b>. If so, first remove the mapping and then remove the agent.</li>
                                <li>Click on the <b>Trash</b> icon to remove an agent.</li>
                            </ol>
                        </div>
                        <br/>

                        <h3>Agent last location</h3>
                        <div style={{textAlign: "left"}}>
                            <ol>
                                <li>Go to the <b>Agents</b> page.</li>
                                <li>Click on the <b>Last location</b> column or <b>Maps</b> icon to open the last location on Google maps.</li>
                            </ol>
                        </div>
                        <br/>

                        <h3>Request Agent location</h3>
                        <div style={{textAlign: "left"}}>
                            <ol>
                                <li>Go to the <b>Agents</b> page.</li>
                                <li>Click on the <b>Reload</b> icon to request location. <br/><b>Note:</b> The location request update can take more than few seconds to update. The Page will refresh on its own.</li>
                            </ol>
                        </div>
                        <br/>
                    </Collapsible>
                    <Collapsible key="Route" title="Route">
                        <h3>Create Route</h3>
                        <div style={{textAlign: "left"}}>
                            <ol>
                                <li>Click on the + Button</li>
                                <li>Enter the <b>Route Name</b></li>
                                <li>Assign <b>Agent</b> to the route by clicking the <b>Assign</b> icon and selecting an agent.</li>
                            </ol>
                        </div>
                        <br/>

                        <h3>Remove Agent mapping</h3>
                        <div style={{textAlign: "left"}}>
                            <ol>
                                <li>Go to the <b>Routes</b> page.</li>
                                <li>Click on the <b>X</b> icon to remove agent mapping.</li>
                            </ol>
                        </div>
                        <br/>

                        <h3>Reassign Agent to a Route</h3>
                        <div style={{textAlign: "left"}}>
                            <ol>
                                <li>Go to the <b>Routes</b> page.</li>
                                <li>Click on the <b>User</b> icon to reassign an agent.</li>
                            </ol>
                        </div>
                        <br/>

                        <h3>Remove Route</h3>
                        <div style={{textAlign: "left"}}>
                            <ol>
                                <li>Go to the <b>Routes</b> page.</li>
                                <li>Make sure there are no agents associated with a <b>Routes</b> before removing it.</li>
                                <li>Click on the <b>Trash</b> icon to remove a route.</li>
                            </ol>
                        </div>
                        <br/>
                    </Collapsible>
                    <Collapsible key="Inducting an Agent" title="Inducting an Agent">
                        <div style={{textAlign: "left"}}>
                            <ol>
                                <li>Go to the <b>Agent</b> page.</li>
                                <li>Click on the + Button</li>
                                <li>Assign <b>Roles</b> to the agent. (On highlighting the roles, you can see the access it grants)</li>
                                <li>Click <b>Create Agent</b> button</li>
                                <li>Once the agents are created, they will be in deactivated state. To activate an agent click on <b>Activate/Deactivate</b> icon. Once active they will be able to log into the mobile devices.</li>
                                <li>Then go to the <b>Routes</b> Page</li>
                                <li>Check for the <b>Route</b> to which you want to associate this agent. If the route is not available, create a new <b>Route</b>. (Check the <b>How to?</b> Route section)</li>
                                <li>Assign <b>Agent</b> to the route by clicking the <b>Assign</b> icon and selecting an agent.</li>
                            </ol>
                        </div>
                    </Collapsible>
                    <Collapsible key="Importing the Schedules" title="Importing the Schedules">
                        <div style={{textAlign: "left"}}>
                            <ol>
                                <li>Go to the <b>Import</b> page.</li>
                                <li>Select the <b>Route</b>.</li>
                                <li>Choose the import file.
                                    <br/>
                                    <b>Note:</b> Only Daily Ninja file import format is supported.
                                </li>
                                <li>Click <b>Import</b> button</li>
                                <li>You can confirm if the import was successful by clicking on the <b>Reports</b> > <b>Schedule Report</b> Page.</li>
                            </ol>
                        </div>
                    </Collapsible>
                    <Collapsible key="Exporting the Schedules" title="Exporting the Schedules">
                        <div style={{textAlign: "left"}}>
                            <ol>
                                <li>Go to the <b>Export</b> page.</li>
                                <li>Select the <b>Date</b> for which export is required.
                                    <br/>
                                    <b>Note:</b> Only .XLSX Tally file export format is supported.
                                </li>
                                <li>Click <b>Download</b> button</li>
                            </ol>
                        </div>
                    </Collapsible>
                    <Collapsible key="Inducting a Store and Creating Deliveries" title="Inducting a Store and Creating Deliveries">
                        <h3>Creating Store and Mapping it to a Route</h3>
                        <div style={{textAlign: "left"}}>
                            <ol>
                                <li>Go to the Store Menu > <b>Store List</b> page.</li>
                                <li>Click on the + Button.</li>
                                <li>Enter the Store details.</li>
                                <li>Enter the Commission per Product.</li>
                                <li>Click <b>Save</b> button</li>
                                <li>Once the Store is created, you have to map the store to a route</li>
                                <li>Click on the Store Menu > <b>Store Route Mapping</b> page.</li>
                                <li>Check for the <b>Route</b> to which you want to associate this store. Click on the <Glyphicon glyph="circle-arrow-up"/> icon and select route.</li>
                                <li>Once assigned a route, the store is ready for orders.</li>
                            </ol>
                        </div>
                        <br/>

                        <h3>Searching for Store Deliveries</h3>
                        <div style={{textAlign: "left"}}>
                            <ol>
                                <li>Go to the Store Menu > <b>Store Delivery Schedule</b> page.</li>
                                <li>Click the Schedule date for which you want to search for deliveries.</li>
                                <li>The dates in Green indicate that there are deliveries scheduled for stores on that particular date.</li>
                            </ol>
                        </div>
                        <br/>

                        <h3>Creating Store Deliveries</h3>
                        <div style={{textAlign: "left"}}>
                            <ol>
                                <li>Go to the Store Menu > <b>Store Delivery Schedule</b> page.</li>
                                <li>Click the Schedule date for which you want to create delivery.</li>
                                <li>Click on the + Button</li>
                                <li>Select the Store</li>
                                <li>Enter the quantities against each product</li>
                                <li>Click <b>Schedule</b> button</li>
                                <li>Once the Store Schedule is created, you will be able to see the delivery details below the calendar.</li>
                            </ol>
                        </div>
                        <br/>
                    </Collapsible>
                    <Collapsible key="Re-send Email Invoice" title="Re-send Email Invoice">
                        <div style={{textAlign: "left"}}>
                            <ol>
                                <li>Go to the Store Menu > <b>Store Delivery Schedule</b> page.</li>
                                <li>Click the Schedule date for which you want to resend invoice.</li>
                                <li>Click on the <Glyphicon glyph="envelope"/> icon against the store you want to send invoice.</li>
                                <li>Click on confirm button to send the email.</li>
                            </ol>
                        </div>
                    </Collapsible>
                    <Collapsible key="Route Mapping using Google API for Customer Apps" title="Route Mapping in Google for Customer Apps">
                        <div style={{textAlign: "left"}}>
                            <ol>
                                <li style={{marginBottom:"20px"}}>Go to the Google url <span style={{color: "blue", cursor: "pointer"}} onClick={(e) => { window.open("https://mapsengine.google.com/map/", "_blank") }}>Google Maps Engine</span></li>
                                <li style={{marginBottom:"20px"}}>Click "+ Create a new map"
                                    <br/><img alt="" height="150px" src="/images/help/1.png"/>
                                </li>
                                <li style={{marginBottom:"20px"}}>Type Bengaluru in the search area</li>
                                <li style={{marginBottom:"20px"}}>Click on Draw a new Line option by selecting Add new line or shape.
                                    <br/><img alt="" height="250px" src="/images/help/2.png"/>
                                </li>
                                <li style={{marginBottom:"20px"}}>Create a Polygon and name it as per the same Route name used in the HappyMilk System.
                                    <br/><img alt="" height="300px" src="/images/help/3.png"/>
                                </li>
                                <li style={{marginBottom:"20px"}}>Repeat Steps 4 and 5 to create the route to Delivery Map.</li>
                                <li style={{marginBottom:"20px"}}>Click Export to KML/KMZ option.
                                    <br/><img alt="" height="300px" src="/images/help/4.png"/>
                                </li>
                                <li style={{marginBottom:"20px"}}>Click Export to a .KML file option. And click Download.
                                    <br/><img alt="" height="300px" src="/images/help/5.png"/>
                                </li>
                                <li style={{marginBottom:"20px"}}>Rename the file to "route_mapping.kml".</li>
                                <li style={{marginBottom:"20px"}}>Upload the Mapping into <span style={{color: "blue", cursor: "pointer"}} onClick={(e) => { window.open("/import", "_blank") }}>Import</span>.</li>
                                <li style={{marginBottom:"20px"}}>This Area Mapping will be updated for Customers automatically.</li>
                            </ol>
                        </div>
                    </Collapsible>
                    <Collapsible key="Mapping Delivery area using Google API for Customer Apps" title="Mapping Delivery area using Google API for Customer Apps">
                        <div style={{textAlign: "left"}}>
                            <ol>
                                <li style={{marginBottom:"20px"}}>Go to the Google url <span style={{color: "blue", cursor: "pointer"}} onClick={(e) => { window.open("https://mapsengine.google.com/map/", "_blank") }}>Google Maps Engine</span></li>
                                <li style={{marginBottom:"20px"}}>Click "+ Create a new map"
                                    <br/><img alt="" height="150px" src="/images/help/1.png"/>
                                </li>
                                <li style={{marginBottom:"20px"}}>Type Bengaluru in the search area</li>
                                <li style={{marginBottom:"20px"}}>Click on Draw a new Line option by selecting Add new line or shape.
                                    <br/><img alt="" height="250px" src="/images/help/2.png"/>
                                </li>
                                <li style={{marginBottom:"20px"}}>Create a Polygon to represent the servicable area and name it.
                                    <br/><img alt="" height="300px" src="/images/help/6.png"/>
                                </li>
                                <li style={{marginBottom:"20px"}}>Click Export to KML/KMZ option.
                                    <br/><img alt="" height="300px" src="/images/help/7.png"/>
                                </li>
                                <li style={{marginBottom:"20px"}}>Click Export to a .KML file option. And click Download.
                                    <br/><img alt="" height="300px" src="/images/help/8.png"/>
                                </li>
                                <li style={{marginBottom:"20px"}}>Rename the file to "delivery_area.kml".</li>
                                <li style={{marginBottom:"20px"}}>Upload the Mapping into <span style={{color: "blue", cursor: "pointer"}} onClick={(e) => { window.open("/import", "_blank") }}>Import</span>.</li>
                            </ol>
                        </div>
                    </Collapsible>
                </div>
        </div>
        );
    }
}